export const isImg = (element) => {
    if (!element || typeof element !== 'object') {
        return;
    }
    return element.tagName === 'IMG';
};
